import * as React from "react";
import { Routes, Route } from "react-router-dom";
import { MepAnalysisListScreen } from "./MepAnalysisListScreen";
import { MepSessionsListScreen } from "./MepSessionsListScreen";
import { MepAnalysisScreen } from "./MepAnalysisScreen";
import { PrivateRoute } from "../../../Core/PrivateRoute";
import { PermissionEnum } from "../../../misc/api/ApiPermissionEnum";

export const MepRoot = () => {
    return (
        <Routes>
            <Route index
                element={
                    <PrivateRoute permissions={[PermissionEnum.AccessSingleMepSession, PermissionEnum.AccessAllMepSessions, PermissionEnum.OverreadMepSession]}>
                        <MepSessionsListScreen />
                    </PrivateRoute>
                }
            />
            <Route path="Analysis" element={
                <PrivateRoute permissions={[PermissionEnum.OverreadMepSession]}>
                    <MepAnalysisListScreen />
                </PrivateRoute>
            }
            />
            <Route path="Analysis/:analysisSetId/:viewState" element={
                <PrivateRoute permissions={[PermissionEnum.OverreadMepSession, PermissionEnum.AccessSingleMepSession]}>
                    <MepAnalysisScreen />
                </PrivateRoute>
            }
            />
        </Routes>
    );
}
